<div class="row" [ngClass]="{ 'modal-container popup-general modal-md percent_35': isModal}" *ngIf="formSms">


    <div class="modal-container-header col-12" *ngIf="isModal">
        <span>{{ "gestion_terceros.popup.enviarSms" | translate }}</span>
        <span class="k-icon k-i-close" (click)="closeModal(false)"></span>
    </div>

    <div class="modal-container-section col-12 mt-1">

        <form [formGroup]="formSms" [ngClass]="{ 'contenedor-base': !isModal}">

            <div class="row text-size-small ">
                <div class="col-12 ">
                    <div class="form-group fila-input">
                        <label class="anchurax20 text-right mr-1">
                            {{ "labels.telephone" | translate }}:</label>
                        <input formControlName="Phone" type="text" class="form-control inline anchurax70 " [maxlength]="11"/>
                    </div>
                </div>

                <div class="col-12 mt-1">
                    <div class="form-group fila-textarea">
                        <label class="text-right anchurax20 mr-1">
                            {{ "labels.textSms" | translate }}:</label>
                        <textarea maxLength="160" formControlName="Description"
                            class="inline anchurax70 form-control noResize altura" kendoTextArea></textarea>
                        <p class="color_naranja reset text-size-small ml-1"> {{ contadorCaracteres }}/160
                        </p>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-end mt-2">

                <!-- [disabled]="!comprobarCampos()" -->
                <button [disabled]="!formSms.valid" type="button" (click)="closeModal(true)"
                    class="btn btn-secondary float-right">
                    {{ "gestion_terceros.popup.enviarSms" | translate }}
                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                </button>
            </div>

        </form>

    </div>

</div>
